import styled from "@emotion/styled";

const PortfolioItemLeft = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.breakpoints.down("lg")} {
    font-size: 15px;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 20px;
  }

  ${({ theme }) => theme.breakpoints.up("lg")} {
    width: 47%;
    font-size: 24px;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 20px;
  }
`;

export default PortfolioItemLeft;
